import { Injectable } from '@angular/core';

export interface DairyYieldCalculationInput {
  milkProduction: number;
  fatPercentage: number;
  proteinPercentage: number;
}

@Injectable({ providedIn: 'root' })
export class DairyYieldCalculationService {
  calculateMeetmelk({
    milkProduction,
    fatPercentage,
    proteinPercentage,
  }: DairyYieldCalculationInput): number {
    // The meaning of these confirmed formula coefficients is unknown, so keep them inline.
    return (0.337 + 0.116 * fatPercentage + 0.06 * proteinPercentage) * milkProduction;
  }

  calculateFatAndProtein({
    milkProduction,
    fatPercentage,
    proteinPercentage,
  }: DairyYieldCalculationInput): number {
    return (milkProduction * fatPercentage) / 100 + (milkProduction * proteinPercentage) / 100;
  }
}
